import { createTheme } from '@mui/material/styles';

const theme = createTheme({
    palette: {
        primary: {
            light: '#757ce8',
            main: '#041E42',
            dark: '#041E42',
            contrastText: '#fff',
        },
            secondary: {
            light: '#ff7961',
            main: '#f44336',
            dark: '#ba000d',
            contrastText: '#000',
        },
    },
    typography: {
        fontFamily: 'SF Pro Display',
        button: {
            textTransform: 'none'
        }
    }
});

export default theme;
